import { useEffect, useState } from "react";

/**
 * DOZE SEGUNDOS DE SILÊNCIO FAZEM A PESSOA RECARREGAR — e recarregar reinicia o
 * boot, sem ganhar nada.
 *
 * Decisão do Ruddy (15/08), junto do terceiro estado do boot: o painel passou a
 * SEGURAR a tela quando ainda não sabe se há usuário (em vez de expulsar pro
 * /login com a credencial boa na mão). Segurar é o conserto — mas segurar CALADO
 * tem um custo próprio: quem olha pra um "Carregando…" mudo por vários segundos
 * conclui que travou, dá F5, e o F5 joga fora o trabalho do boot que estava
 * quase terminando.
 *
 * A linha extra é cosmética e é exatamente isso que ela compra: a diferença
 * entre "está esperando" e "travou". Não muda prazo nenhum, não decide nada.
 *
 * ⚠️ `AVISO_ESPERA_MS` NÃO É UM PRAZO. Ele não interrompe, não desiste, não
 * decide coisa alguma — só diz a partir de quando a frase aparece. O único
 * relógio que DECIDE no boot continua sendo o `TETO_PERFIL_MS` do `useAuth`, e
 * ele é um só de propósito.
 */
const AVISO_ESPERA_MS = 4_000;

export function CarregandoSessao({ classe = "p-8 text-muted-foreground" }: { classe?: string }) {
  const [demorou, setDemorou] = useState(false);

  useEffect(() => {
    const t = window.setTimeout(() => setDemorou(true), AVISO_ESPERA_MS);
    return () => window.clearTimeout(t);
  }, []);

  return (
    <div className={classe}>
      <div>Carregando…</div>
      {demorou && (
        <div className="text-xs mt-1 opacity-80">
          Verificando sua sessão — não precisa recarregar.
        </div>
      )}
    </div>
  );
}
